export default __webpack_public_path__ + "static/media/Move.18759ee3.mp3";